import { fetchBaseQuery } from "@reduxjs/toolkit/query";

import { authApi } from "./services/auth";
import {setAccessToken} from './slices/user.slice'

// Define base query with authorization header
export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.BACKEND_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryWithReauth = async (args, store, extraOptions) => {
  let result = await baseQuery(args, store, extraOptions);
  
  if (result.error && result.error.status === 401) {
    const refresh_token = localStorage.getItem("refresh_token");
    // Try to refresh the token
    if (refresh_token) {
      const refreshResult = await baseQuery(
        `/auth/refresh?refresh_token=${refresh_token}`,
        store,
        extraOptions
      );

      if (refreshResult.data) {
        // Store the new tokens
        localStorage.setItem("access_token", refreshResult.data.access_token);
        localStorage.setItem("refresh_token", refreshResult.data.refresh_token)
        
        store.dispatch(setAccessToken(refreshResult.data.access_token));
        // Retry the original request
        result = await baseQuery(args, store, extraOptions);
      } else {
        store.dispatch(authApi.endpoints.logout.initiate());
      }
    } else {
      store.dispatch(authApi.endpoints.logout.initiate());
    }
  }
  return result;
};
